import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BorrowerStatusesState } from 'ng2-app/store/borrowerStatuses/borrower-statuses.state';
import { BorrowerStatusOption } from 'ng2-app/store/borrowerStatuses/borrower-statuses.service';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { BorrowerStatusChange } from 'ng2-app/borrower-header/borrower-status-picker/borrower-status-picker/borrower-status-picker.component';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { GetBorrowerStatusReasons } from 'ng2-app/store/borrower-status-reason/borrower-status-reason.actions';
import { BorrowerStatusReasonState } from 'ng2-app/store/borrower-status-reason/borrower-status-reason.state';
import { ChangeBorrowerStatus } from 'ng2-app/store/borrower/borrower/borrower.actions';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';

@Component({
  selector: 'app-account-delete-dialog',
  templateUrl: './change-borrower-status-dialog.component.html',
  styleUrls: ['./change-borrower-status-dialog.component.scss']
})
export class ChangeBorrowerStatusDialogComponent implements OnInit, OnDestroy {

  @Select( BorrowerState.borrowerId ) borrowerId$: Observable<number>;
  @Select( BorrowerStatusesState.nurtureStatusOptions ) statusOptions$: Observable<BorrowerStatusOption[]>;
  @Select( BorrowerStatusReasonState.reasons ) reasons$: Observable<any>;
  @Output() statusChange = new EventEmitter<BorrowerStatusChange>();

  destroyed$ = new Subject<boolean>();


  selectedOption;
  reasons;

  // formly
  form = new UntypedFormGroup({});
  model = {
    reason: null
  };
  fields: FormlyFieldConfig[] = [
    {
      key: 'reason',
      type: 'select',
      templateOptions: {
        label: 'Reason',
        required: true,
        options: [],
        valueProp: 'reason',
        labelProp: 'reason',
        attributes: {
          'data-cy': 'borrower-status-reason-select',
        }
      },
      expressionProperties: {
        'templateOptions.options': () => {
          return this.reasons.filter( reason => reason.status === this.selectedOption.status );
        }
      }
    }
  ];

  dncForm = new UntypedFormGroup({});
  dncModel = {
    isNyState: null,
    methods: [],
  };
  dncFields: FormlyFieldConfig[] = [
    {
      key: 'isNyState',
      type: 'radio',
      templateOptions: {
        appearance: 'legacy',
        label: 'Is this borrower\'s business located primarily in NY state?',
        required: true,
        options: [
          { value: 1, label: 'Yes' },
          { value: 0, label: 'No' },
        ],
      }
    },
    {
      key: 'methods',
      type: 'indeterminate-checkbox',
      templateOptions: {
        appearance: 'legacy',
        type: 'array',
        label: 'Which method did the borrower request DNC?',
        required: true,
        options: [
          {
            label: 'SMS',
            value: 'sms',
          },
          {
            label: 'Email',
            value: 'email',
          },
          {
            label: 'Calls',
            value: 'calls',
          },
        ]
      },
    }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ChangeBorrowerStatusDialogComponent>,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.store.dispatch(new GetBorrowerStatusReasons());
    // pull reasons off to plain attribute for use with formly
    this.reasons$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe( reasons => this.reasons = reasons);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleSelectionChange(option) {
    const previousOption = this.selectedOption;
    if (option.value === previousOption || option.disabledReason) {
      return false;
    }

    if (option.borrower_stage_lookup.stage !== 'inactive') {
      this.selectedOption = option;
      this.statusChange.emit({
        status: option.value,
        reason: null
      });
      return;
    }

  }

  confirmChangeStatus() {
    this.borrowerId$.pipe(take(1)).subscribe(borrowerId => {
      const action = this.selectedOption.status === 'doNotContact' ?
        new ChangeBorrowerStatus( borrowerId, 'doNotContact', 'Do Not Contact', this.dncModel) :
        new ChangeBorrowerStatus( borrowerId, this.selectedOption.status, this.model.reason);

      this.store.dispatch( action );
      this.dialogRef.close();
    });
  }

}
